import { TaskState } from "common/constants";
import Api from "js/core/api";
import pusher from "js/core/services/pusher";
import log from "js/core/logger";
import genExportChannelId from "common/utils/genExportChannelId";

export async function requestExportCache(onEvent, taskProps) {
    const channelId = genExportChannelId(taskProps);

    log.info(log.EXPORT_CACHE)(`requestExportCache() will subscribe to channel ${channelId}`);

    const channel = await pusher.subscribe(channelId);
    if (!channel) {
        throw new Error("Pusher is disabled");
    }

    const unsubscribe = () => {
        channel.unbind_all();
        channel.unsubscribe();
    };

    const bindEvent = state => {
        channel.bind(state, data => {
            log.info(log.EXPORT_CACHE)(`requestExportCache() channel event ${state} received, data:\n${JSON.stringify(data, null, 2)}`);

            if ([TaskState.FINISHED, TaskState.ERROR].includes(state)) {
                unsubscribe();
            }

            onEvent({
                ...data,
                state,
            });
        });
    };
    bindEvent(TaskState.PREPARING);
    bindEvent(TaskState.PROCESSING);
    bindEvent(TaskState.FINISHED);
    bindEvent(TaskState.ERROR);

    await Api.exportCache.post(taskProps);

    return { cancel: unsubscribe };
}
